import { useQuery } from '@tanstack/react-query';
import api from '@app/services/api';
import { apiEndpoints } from '@app/utils/constants';
import type { UseQueryOptions } from '@tanstack/react-query';
import type { ApiError, ChannelPartnerListParams, ChannelPartnerListResponse } from '@app/services/api.types';

type QueryOptions = Omit<UseQueryOptions<ChannelPartnerListResponse, ApiError>, 'queryKey' | 'queryFn'>;

export const fetchChannelPartnerList = async (params: ChannelPartnerListParams): Promise<ChannelPartnerListResponse> => {
	const url = apiEndpoints.channel.getList(params);
	const response = await api.get(url);
	return response?.data?.data;
};

const useChannelPartners = (params: ChannelPartnerListParams, options?: QueryOptions) => {
	return useQuery<ChannelPartnerListResponse, ApiError>({
		queryKey: ['channelPartner', 'list', params],
		queryFn: () => fetchChannelPartnerList(params),
		...options,
	});
};

export default useChannelPartners;
